import { text } from './RandomText.js';


export function CodeLayer(props: any) {



    return <p className="backdrop-code prevent-select">{text + text}</p>
}